module.exports = __webpack_public_path__ + "static/media/den-flag.a8aa3738.svg";